export const GET_CONFIG = "GET_CONFIG@configuration";
export const GET_CONFIG_SUCCESS = "GET_CONFIG_SUCCESS@configuration";
export const SET_MOBILE_MODE = "SET_MOBILE_MODE@configuration";
export const GET_TOKEN = "GET_TOKEN@configuration";
